var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FocusTrap',{class:[
    // Covers other elements on page
    'fixed',
    'inset-0',
    'z-modal2',

    // Transitions
    { fade: _vm.shouldFadeIn },

    // Scrim
    _vm.scrim === 'modal' && {
      'bg-modal-overlay-light': _vm.darkMode === false,
      'bg-modal-overlay-dark': _vm.darkMode === true,
      'bg-modal-overlay-light dark:bg-modal-overlay-dark': _vm.darkMode === 'auto',
    },
    _vm.scrim === 'popover' && {
      'bg-popover-overlay-light': _vm.darkMode === false,
      'bg-popover-overlay-dark': _vm.darkMode === true,
      'bg-popover-overlay-light dark:bg-popover-overlay-dark': _vm.darkMode === 'auto',
    },

    // Misc
    'touch-action-manipulation',
    'pointer-events-auto' ],nativeOn:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.scrimClick($event)},"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }$event.stopPropagation();$event.preventDefault();return _vm.scrimEsc($event)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }